// extracted by mini-css-extract-plugin
export default {"wrap":"EmptyState_wrap__PBI+4","title":"EmptyState_title__fl4Vf","subtitle":"EmptyState_subtitle__nUaIM","btn":"EmptyState_btn__9X9Ol"};